import useIsTruncated from '@hooks/useIsTruncated';

import Icon from '../icon/Icon';
import Tooltip from '../tooltip/Tooltip';

import theme from '../../../themes/colors';

interface LabelProps {
  label: string;
  optionalText?: string;
  tooltipText?: string;
  className?: string;
  tooltipId?: string;
  tooltipStyle?: string;
  isRequired?: boolean;
  type?: 'default' | 'hasSubtext';
  /** Clip label to a single line with an ellipsis; full text shows in a tooltip on hover. */
  truncate?: boolean;
}

const Label = (props: LabelProps) => {
  const {
    label,
    optionalText,
    tooltipText,
    className,
    tooltipId,
    tooltipStyle,
    isRequired,
    type = 'default',
    truncate = false
  } = props;
  const truncatedLabelTooltipId = `${
    tooltipId || label.replace(/\s+/g, '-')
  }-truncated-label-tooltip`;
  const { ref: truncatedLabelRef, isTruncated } =
    useIsTruncated<HTMLDivElement>(label);

  return (
    <>
      {type === 'default' && (
        <div
          className={`mb-4 flex items-center gap-1 text-sm font-semibold text-cofeeNeutral10 ${className}`}
        >
          <div
            ref={truncate ? truncatedLabelRef : undefined}
            className={truncate ? 'min-w-0 truncate' : undefined}
            data-tooltip-id={
              truncate && isTruncated ? truncatedLabelTooltipId : undefined
            }
          >
            {label}
            <span className="ml-1 text-grey60">{optionalText}</span>
            {isRequired && <span className="text-error">*</span>}
          </div>
          {truncate && isTruncated && (
            <Tooltip
              id={truncatedLabelTooltipId}
              type="text"
              tooltipText={label}
              place="bottom"
              className="max-w-80"
            />
          )}
          {tooltipText && (
            <>
              <Icon
                name="alert-circle"
                stroke={theme.subText}
                data-tooltip-id={`${tooltipId}-label-tooltip`}
              />
              <Tooltip
                id={`${tooltipId}-label-tooltip`}
                type="text"
                tooltipText={tooltipText}
                className={tooltipStyle}
              />
            </>
          )}
        </div>
      )}
      {type === 'hasSubtext' && (
        <>
          <div className="text-sm font-semibold text-grey">{label}</div>
          <div className="my-2 flex items-center gap-1 text-xs text-grey60">
            <Icon name="alert-circle" stroke={theme.subText} size="none" />
            {tooltipText}
          </div>
        </>
      )}
    </>
  );
};

export default Label;
